// extracted by mini-css-extract-plugin
export default {"Header":"HeaderSearch_Header__l26zO","HiderSide":"HeaderSearch_HiderSide__itFAF","Title":"HeaderSearch_Title__B0Y2-","HeaderSideLeft":"HeaderSearch_HeaderSideLeft__xhaqD"};